exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .numerico{min-width:65px;text-align:right}.consulta__total{display:flex;align-items:center;justify-content:center}.consulta__total_valor{font-size:40px;display:block;line-height:normal}.consulta__cifrao{font-size:16px;display:block;line-height:normal}.resumo__performance{display:flex;align-items:center;justify-content:space-between}.resumo__performance__value{padding:5px 15px;font-size:18px;font-weight:600;text-align:left;border-radius:10%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b511139","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/consultas/consulta-curva-cliente.vue
// module id = 1314
// module chunks = 0